/* eslint-disable max-len */
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";
import { IAllServiceStatusState, serviceStatusActions } from "../../../state/all-service-status";

export const useAllServiceStatusStore = () => {
  const dispatch = useDispatch();
  const {
    isDropOffServiceAvailable,
    isIntegratedServiceAvailable,
    isExpressServiceAvailable,
    isWellnessServiceAvailable,
    isOnlinePharmacyServiceAvailable,
    isServiceStatusStoreUpdated,
    isUrgentCareOnly,
  } = useSelector((state: IRootState) => state.allServiceStatus as IAllServiceStatusState);

  const setDropoffServiceStatus = (isServiceAvailable: boolean) => {
    dispatch(serviceStatusActions.setDropoffServiceStatus(isServiceAvailable));
  };
  const setWellnessServiceStatus = (isServiceAvailable: boolean) => {
    dispatch(serviceStatusActions.setWellnessServiceStatus(isServiceAvailable));
  };
  const setIntegratedServiceStatus = (isServiceAvailable: boolean) => {
    dispatch(serviceStatusActions.setIntegratedServiceStatus(isServiceAvailable));
  };
  const setExpressServiceStatus = (isServiceAvailable: boolean) => {
    dispatch(serviceStatusActions.setExpressServiceStatus(isServiceAvailable));
  };
  const setOnlinePharmacyServiceStatus = (isServiceAvailable: boolean) => {
    dispatch(serviceStatusActions.setOnlinePharmacyServiceStatus(isServiceAvailable));
  };
  const setServiceStatusStoreUpdated = (isServiceAvailable: boolean) => {
    dispatch(serviceStatusActions.setServiceStatusStoreUpdated(isServiceAvailable));
  };
  const setIsUrgentCareOnly = (isUrgentCareOnly: boolean) => {
    dispatch(serviceStatusActions.setIsUrgentCareOnly(isUrgentCareOnly));
  };
  const resetServiceStatusStore = () => {
    dispatch(serviceStatusActions.resetServiceStatusStore());
  };


  return {
    isDropOffServiceAvailable,
    isIntegratedServiceAvailable,
    isExpressServiceAvailable,
    isWellnessServiceAvailable,
    isOnlinePharmacyServiceAvailable,
    isServiceStatusStoreUpdated,
    isUrgentCareOnly,
    setDropoffServiceStatus,
    setWellnessServiceStatus,
    setIntegratedServiceStatus,
    setExpressServiceStatus,
    setOnlinePharmacyServiceStatus,
    setServiceStatusStoreUpdated,
    setIsUrgentCareOnly,
    resetServiceStatusStore,
  };
};

export default useAllServiceStatusStore;

